// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .task-form-container {
    padding: 1rem;
  }
}

.modal-mode-task-content-task-form-container {
  padding: 0rem !important;
  min-height: auto;
}

.task-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: task-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .task-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.task-form-wrapper .task-form-header {
  position: relative;
  text-align: center;
  margin-bottom: 0rem;
}
.task-form-wrapper .task-form-header .task-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .task-form-wrapper .task-form-header .task-form-title {
    font-size: 1.25rem;
  }
}
.task-form-wrapper .task-form-header .modal-mode-task-content-task-form-title {
  font-size: 1.3rem !important;
  font-weight: 500 !important;
}
.task-form-wrapper .task-form-header .task-form-close-button {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 24px;
  background: transparent;
  border: none;
  color: #374151;
  cursor: pointer;
  z-index: 2;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.task-form-wrapper .task-form-header .task-form-close-button:hover {
  color: #111827;
  background-color: #f3f4f6;
}
.task-form-wrapper .task-status-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  margin: 1.5rem 0 0 0;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  background-color: #f9fafb;
}
.task-form-wrapper .task-status-section .current-status,
.task-form-wrapper .task-status-section .status-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.task-form-wrapper .task-status-section .status-label {
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.task-form-wrapper .task-status-section .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  border-radius: 9999px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: white;
}
.task-form-wrapper .task-status-section .status-badge svg {
  color: white;
}
.task-form-wrapper .task-status-section .status-buttons {
  display: flex;
  gap: 0.75rem;
}
.task-form-wrapper .task-status-section .status-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  border: 1.5px solid;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease-in-out;
}
.task-form-wrapper .task-status-section .status-button:hover:not(:disabled) {
  opacity: 0.8;
  transform: translateY(-1px);
}
.task-form-wrapper .task-status-section .status-button.active {
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.task-form-wrapper .task-status-section .status-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}
.task-form-wrapper .task-status-section .status-button:disabled:hover {
  opacity: 0.6;
}
.task-form-wrapper .task-form-divider {
  border: none;
  border-top: 1px solid var(--grey-shade-two);
  margin: 1.5rem 0;
}
.task-form-wrapper .task-tabs {
  display: flex;
  border: 1px solid var(--grey-shade-three);
  border-radius: 0.375rem 0.375rem 0 0;
  overflow: hidden;
  margin-bottom: 0;
}
.task-form-wrapper .task-tabs .tab-button {
  flex: 1 1;
  padding: 1rem 1.5rem;
  background: #ffffff;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  color: #6b7280;
}
.task-form-wrapper .task-tabs .tab-button.active {
  background-color: var(--grey-shade-two);
  color: #374151;
  border-bottom: 2px solid var(--grey-shade-one);
}
.task-form-wrapper .task-tabs .tab-button:hover:not(.active) {
  background-color: var(--grey-lightest-shade);
}
.task-form-wrapper .modal-mode-task-content {
  width: 100% !important;
  margin: 0 !important;
}
.task-form-wrapper .task-form-content,
.task-form-wrapper .form-content {
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  background-color: #ffffff;
  margin: 0 -1.5rem -1.5rem -1.5rem;
}
@media (max-width: 768px) {
  .task-form-wrapper .task-form-content,
  .task-form-wrapper .form-content {
    padding: 1rem;
    margin: 0 -1rem -1rem -1rem;
  }
}
.task-form-wrapper .form-section {
  margin-bottom: 1.5rem;
}
.task-form-wrapper .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.task-form-wrapper .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--grey-shade-two);
}
.task-form-wrapper .form-group {
  margin-bottom: 0.7rem;
  width: 100%;
}
.task-form-wrapper .form-group:last-child {
  margin-bottom: 0;
}
.task-form-wrapper .form-group .label-task {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.task-form-wrapper .form-group .label-task .required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.task-form-wrapper .form-group input[type=text],
.task-form-wrapper .form-group input[type=date],
.task-form-wrapper .form-group input[type=time],
.task-form-wrapper .form-group input[type=url],
.task-form-wrapper .form-group select,
.task-form-wrapper .form-group .custom-dropdown-input,
.task-form-wrapper .form-group .textInput,
.task-form-wrapper .form-group .selectInput {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151 !important;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.task-form-wrapper .form-group input[type=text]:focus,
.task-form-wrapper .form-group input[type=date]:focus,
.task-form-wrapper .form-group input[type=time]:focus,
.task-form-wrapper .form-group input[type=url]:focus,
.task-form-wrapper .form-group select:focus,
.task-form-wrapper .form-group .custom-dropdown-input:focus,
.task-form-wrapper .form-group .textInput:focus,
.task-form-wrapper .form-group .selectInput:focus {
  outline: none;
  border-color: var(--primary-light-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .form-group input[type=text]:hover:not(:focus),
.task-form-wrapper .form-group input[type=date]:hover:not(:focus),
.task-form-wrapper .form-group input[type=time]:hover:not(:focus),
.task-form-wrapper .form-group input[type=url]:hover:not(:focus),
.task-form-wrapper .form-group select:hover:not(:focus),
.task-form-wrapper .form-group .custom-dropdown-input:hover:not(:focus),
.task-form-wrapper .form-group .textInput:hover:not(:focus),
.task-form-wrapper .form-group .selectInput:hover:not(:focus) {
  border-color: var(grey-main-bg);
}
.task-form-wrapper .form-group input[type=text]::placeholder,
.task-form-wrapper .form-group input[type=date]::placeholder,
.task-form-wrapper .form-group input[type=time]::placeholder,
.task-form-wrapper .form-group input[type=url]::placeholder,
.task-form-wrapper .form-group select::placeholder,
.task-form-wrapper .form-group .custom-dropdown-input::placeholder,
.task-form-wrapper .form-group .textInput::placeholder,
.task-form-wrapper .form-group .selectInput::placeholder {
  color: var(grey-main-bg);
}
.task-form-wrapper .form-group input[type=text]:disabled,
.task-form-wrapper .form-group input[type=date]:disabled,
.task-form-wrapper .form-group input[type=time]:disabled,
.task-form-wrapper .form-group input[type=url]:disabled,
.task-form-wrapper .form-group select:disabled,
.task-form-wrapper .form-group .custom-dropdown-input:disabled,
.task-form-wrapper .form-group .textInput:disabled,
.task-form-wrapper .form-group .selectInput:disabled {
  background-color: #e9ecef;
  color: #6b7280;
  cursor: not-allowed;
}
.task-form-wrapper .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.task-form-wrapper .form-group .case-selector {
  position: relative;
}
.task-form-wrapper .form-group .case-selector .clear-case-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 1;
}
.task-form-wrapper .form-group .case-selector .clear-case-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.task-form-wrapper .form-group .case-selector .clear-case-button:active {
  background-color: #e5e7eb;
}
.task-form-wrapper .form-group .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: var(--primary-light-color);
  font-weight: 600;
  border-bottom-color: var(--primary-light-color);
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.task-form-wrapper .date-time-wrapper,
.task-form-wrapper .expense-form-flex-row {
  display: flex;
  gap: 1rem;
  width: 100%;
  margin-bottom: 0.7rem;
}
@media (max-width: 768px) {
  .task-form-wrapper .date-time-wrapper,
  .task-form-wrapper .expense-form-flex-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.task-form-wrapper .date-time-wrapper .date-time-group,
.task-form-wrapper .date-time-wrapper .expense-form-col-half,
.task-form-wrapper .expense-form-flex-row .date-time-group,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half {
  flex: 1 1;
  margin-bottom: 0;
}
.task-form-wrapper .date-time-wrapper .date-time-group .time-div-task-content,
.task-form-wrapper .date-time-wrapper .expense-form-col-half .time-div-task-content,
.task-form-wrapper .expense-form-flex-row .date-time-group .time-div-task-content,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .time-div-task-content {
  display: flex;
  justify-content: flex-end;
}
.task-form-wrapper .date-time-wrapper .date-time-group .date-time-input-task,
.task-form-wrapper .date-time-wrapper .expense-form-col-half .date-time-input-task,
.task-form-wrapper .expense-form-flex-row .date-time-group .date-time-input-task,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .date-time-input-task {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.task-form-wrapper .date-time-wrapper .date-time-group .date-time-input-task:focus,
.task-form-wrapper .date-time-wrapper .expense-form-col-half .date-time-input-task:focus,
.task-form-wrapper .expense-form-flex-row .date-time-group .date-time-input-task:focus,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .date-time-input-task:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .date-time-wrapper .date-time-group .date-time-input-task:hover:not(:focus),
.task-form-wrapper .date-time-wrapper .expense-form-col-half .date-time-input-task:hover:not(:focus),
.task-form-wrapper .expense-form-flex-row .date-time-group .date-time-input-task:hover:not(:focus),
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .date-time-input-task:hover:not(:focus) {
  border-color: #9ca3af;
}
.task-form-wrapper .assignee-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.task-form-wrapper .assignee-section .dropdown-container {
  width: 100%;
}
.task-form-wrapper .assignee-section .assignee-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.task-form-wrapper .assignee-section .assignee-tags .assignee-tag {
  display: flex;
  align-items: center;
  background-color: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 0.375rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  color: #374151;
}
.task-form-wrapper .assignee-section .assignee-tags .assignee-tag .remove-assignee {
  margin-left: 0.5rem;
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.task-form-wrapper .assignee-section .assignee-tags .assignee-tag .remove-assignee:hover {
  background-color: #ef4444;
  color: white;
}
.task-form-wrapper .days-selector {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
}
.task-form-wrapper .days-selector .day-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 1.125rem;
  background-color: #ffffff;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  color: #374151;
  position: relative;
}
.task-form-wrapper .days-selector .day-checkbox input[type=checkbox] {
  appearance: none;
  width: 1rem;
  height: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  background: white;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
}
.task-form-wrapper .days-selector .day-checkbox input[type=checkbox]:checked {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
}
.task-form-wrapper .days-selector .day-checkbox:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}
.task-form-wrapper .days-selector .day-checkbox:has(input:checked) {
  border-color: var(--primary-color);
  background-color: #eff6ff;
}
.task-form-wrapper .frequency-dropdown {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.task-form-wrapper .frequency-dropdown:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .frequency-dropdown:hover:not(:focus) {
  border-color: #9ca3af;
}
.task-form-wrapper .rich-text-editor {
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: #ffffff;
}
.task-form-wrapper .rich-text-editor .editor-toolbar {
  display: flex;
  padding: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.task-form-wrapper .rich-text-editor .editor-toolbar button {
  background: none;
  border: none;
  border-radius: 0.25rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.task-form-wrapper .rich-text-editor .editor-toolbar button:hover {
  background-color: #e5e7eb;
  color: #374151;
}
.task-form-wrapper .rich-text-editor .editor-toolbar button.active {
  background-color: #3b82f6;
  color: white;
}
.task-form-wrapper .rich-text-editor .editor-toolbar .divider {
  width: 1px;
  height: 1.25rem;
  background-color: #e5e7eb;
  margin: 0 0.5rem;
  align-self: center;
}
.task-form-wrapper .rich-text-editor .link-input-panel {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.75rem;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-input {
  flex: 1 1;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions {
  display: flex;
  gap: 0.25rem;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn,
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn:disabled,
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn {
  background-color: #16a34a;
  color: white;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn:hover:not(:disabled) {
  background-color: #15803d;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn {
  background-color: #ef4444;
  color: white;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn:hover {
  background-color: #dc2626;
}
.task-form-wrapper .rich-text-editor .editor-container {
  padding: 0.875rem;
  min-height: 100px;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditor-content {
  min-height: 100px;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditor-content a {
  color: #3b82f6 !important;
  text-decoration: underline !important;
  background-color: rgba(59, 130, 246, 0.1) !important;
  padding: 1px 2px !important;
  border-radius: 2px !important;
  cursor: pointer !important;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditor-content a:hover {
  background-color: rgba(59, 130, 246, 0.2) !important;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditorPlaceholder-root {
  color: #9ca3af;
}
.task-form-wrapper .upload-document-group {
  margin-bottom: 1.5rem;
  width: 100%;
}
.task-form-wrapper .upload-document-group .upload-document-container {
  border: 2px dashed var(--grey-main-bg);
  border-radius: 0.375rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;
}
.task-form-wrapper .upload-document-group .upload-document-container:hover {
  border-color: var(--primary-light-color);
  background-color: var(--grey-lightest-shade);
}
.task-form-wrapper .upload-document-group .upload-document-container:focus-within {
  border-color: var(--primary-light-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .upload-document-group .upload-document-container .upload-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  color: #6b7280;
}
.task-form-wrapper .upload-document-group .upload-document-container .upload-icon-container span {
  font-size: 0.875rem;
  font-weight: 500;
}
.task-form-wrapper .upload-document-group .upload-document-container .upload-icon-container .upload-icon {
  color: var(--primary-light-color);
}
.task-form-wrapper .upload-document-group .upload-progress {
  margin-top: 1rem;
  text-align: center;
}
.task-form-wrapper .upload-document-group .upload-progress .progress-bar {
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}
.task-form-wrapper .upload-document-group .upload-progress .progress-bar .progress {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 4px;
  transition: width 0.3s ease;
}
.task-form-wrapper .upload-document-group .upload-progress span {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
}
.task-form-wrapper .upload-document-group .uploaded-file {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.task-form-wrapper .upload-document-group .uploaded-file a {
  color: #0369a1;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  flex: 1 1;
}
.task-form-wrapper .upload-document-group .uploaded-file a:hover {
  text-decoration: underline;
}
.task-form-wrapper .upload-document-group .uploaded-file .cancel-upload-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.task-form-wrapper .upload-document-group .uploaded-file .cancel-upload-button:hover {
  background-color: #dc2626;
}
.task-form-wrapper .upload-document-group .uploaded-file .cancel-upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}
.task-form-wrapper .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  .task-form-wrapper .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.task-form-wrapper .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .task-form-wrapper .form-actions {
    flex-direction: column;
  }
}
.task-form-wrapper .form-actions .btn-save {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .task-form-wrapper .form-actions .btn-save {
    width: 100%;
  }
}
.task-form-wrapper .form-actions .btn-save {
  background-color: var(--primary-color);
  color: white;
}
.task-form-wrapper .form-actions .btn-save:hover {
  background-color: var(--primary-light-color);
}
.task-form-wrapper .form-actions .btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.task-form-wrapper .form-actions .btn-save:focus {
  outline: none;
}
.task-form-wrapper .form-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.task-form-wrapper .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.task-form-wrapper div[role=alert] {
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.modal-mode-task-content-task-form-wrapper {
  width: 100%;
  border: none;
  box-shadow: none;
}

@keyframes task-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 1024px) {
  .task-form-container .date-time-wrapper {
    flex-direction: column;
    gap: 0.5rem;
  }
  .task-form-container .task-form-wrapper {
    width: 85%;
  }
}
@media (max-width: 768px) {
  .task-form-container .task-form-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .task-form-container {
    padding: 0.5rem;
  }
  .task-form-container .task-form-wrapper {
    padding: 0.75rem;
    width: 100%;
  }
  .task-form-container .task-form-content,
  .task-form-container .form-content {
    padding: 1rem;
    margin: 0 -0.75rem -0.75rem -0.75rem;
  }
  .task-form-container .task-form-header .modal-mode-task-content-task-form-title {
    font-size: 0.8rem;
  }
  .task-form-container .task-form-header .task-form-title {
    font-size: 1.125rem;
  }
  .task-form-container .form-group input,
  .task-form-container .form-group select {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .task-form-container .form-actions .btn-save,
  .task-form-container .form-actions .btn-cancel {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .task-form-container {
    background: white;
    padding: 0;
  }
  .task-form-container .task-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .task-form-container .form-actions,
  .task-form-container .task-form-close-button,
  .task-form-container .upload-document-container {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/TaskForm/TaskForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EAVF;IAWI,aAAA;EACF;AACF;;AAEA;EACE,wBAAA;EACC,gBAAA;AACH;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,qCAAA;EACA,UAAA;AAAF;AAEE;EATF;IAUI,aAAA;IACA,WAAA;EACF;AACF;AAEE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAAN;AAEM;EANF;IAOI,kBAAA;EACN;AACF;AAEI;EACE,4BAAA;EACA,2BAAA;AAAN;AAGI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AADN;AAGM;EACE,cAAA;EACA,yBAAA;AADR;AAOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;AALJ;AAOI;;EAEE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AALN;AAQI;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AANN;AASI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;AAPN;AAUM;EACE,YAAA;AARR;AAYI;EACE,aAAA;EACA,YAAA;AAVN;AAaI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;AAXN;AAaM;EACE,YAAA;EACA,2BAAA;AAXR;AAcM;EACE,gBAAA;EACA,wCAAA;AAZR;AAeM;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAbR;AAeQ;EACE,YAAA;AAbV;AAoBE;EACE,YAAA;EACA,2CAAA;EACA,gBAAA;AAlBJ;AAsBE;EACE,aAAA;EACA,yCAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AApBN;AAsBM;EACE,uCAAA;EACA,cAAA;EACA,8CAAA;AApBR;AAuBM;EACE,4CAAA;AArBR;AA0BE;EACE,sBAAA;EACA,oBAAA;AAxBJ;AA4BE;;EAEE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iCAAA;AA1BJ;AA4BI;EATF;;IAUI,aAAA;IACA,2BAAA;EAxBJ;AACF;AA4BE;EACE,qBAAA;AA1BJ;AA4BI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AA1BN;AA6BI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;AA3BN;AAgCE;EACE,qBAAA;EACA,WAAA;AA9BJ;AAgCI;EACE,gBAAA;AA9BN;AAiCI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA/BN;AAiCM;EACE,cAAA;EACA,oBAAA;AA/BR;AAoCI;;;;;;;;EAQE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAlCN;AAoCM;;;;;;;;EACE,aAAA;EACA,wCAAA;EACA,6CAAA;AA3BR;AA8BM;;;;;;;;EACE,+BAAA;AArBR;AAwBM;;;;;;;;EACE,wBAAA;AAfR;AAkBM;;;;;;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AATR;AAaI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAXN;AAeI;EACE,kBAAA;AAbN;AAeM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAbR;AAeQ;EACE,yBAAA;EACA,cAAA;AAbV;AAgBQ;EACE,yBAAA;AAdV;AAkBM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAhBR;AAkBQ;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAhBV;AAkBU;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AAhBZ;AAkBY;EACE,mBAAA;EACA,cAAA;AAhBd;AAmBY;EACE,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,+CAAA;AAjBd;AAsBQ;EACE,iBAAA;EACA,gBAAA;AApBV;AAsBU;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AApBZ;AAsBY;EACE,mBAAA;AApBd;AAuBY;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AArBd;AAuBc;EACE,gBAAA;AArBhB;AA0Bc;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAxBhB;AA2Bc;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AAzBhB;AA4Bc;EACE,kBAAA;EACA,cAAA;AA1BhB;AA+BU;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA7BZ;AAqCE;;EAEE,aAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAnCJ;AAqCI;EAPF;;IAQI,sBAAA;IACA,WAAA;EAjCJ;AACF;AAmCI;;;;EAEE,SAAA;EACA,gBAAA;AA/BN;AAiCM;;;;EACE,aAAA;EACA,yBAAA;AA5BR;AA+BM;;;;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA1BR;AA4BQ;;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAvBV;AA0BQ;;;;EACE,qBAAA;AArBV;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA1BJ;AA4BI;EACE,WAAA;AA1BN;AA6BI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AA3BN;AA6BM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AA3BR;AA6BQ;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AA3BV;AA6BU;EACE,yBAAA;EACA,YAAA;AA3BZ;AAmCE;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAjCJ;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAjCN;AAmCM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAjCR;AAmCQ;EACE,kCAAA;EACA,sCAAA;AAjCV;AAqCM;EACE,yBAAA;EACA,qBAAA;AAnCR;AAsCM;EACE,kCAAA;EACA,yBAAA;AApCR;AA0CE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAxCJ;AA0CI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAxCN;AA2CI;EACE,qBAAA;AAzCN;AA8CE;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;AA5CJ;AA8CI;EACE,aAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EACA,eAAA;EACA,YAAA;AA5CN;AA8CM;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AA5CR;AA8CQ;EACE,yBAAA;EACA,cAAA;AA5CV;AA+CQ;EACE,yBAAA;EACA,YAAA;AA7CV;AAiDM;EACE,UAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA/CR;AAmDI;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;AAjDN;AAmDM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AAjDR;AAmDQ;EACE,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAjDV;AAmDU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjDZ;AAqDQ;EACE,aAAA;EACA,YAAA;AAnDV;AAqDU;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;AAnDZ;AAqDY;;EACE,YAAA;EACA,mBAAA;AAlDd;AAsDU;EACE,yBAAA;EACA,YAAA;AApDZ;AAsDY;EACE,yBAAA;AApDd;AAwDU;EACE,yBAAA;EACA,YAAA;AAtDZ;AAwDY;EACE,yBAAA;AAtDd;AA6DI;EACE,iBAAA;EACA,iBAAA;AA3DN;AA6DM;EACE,iBAAA;AA3DR;AA6DQ;EACE,yBAAA;EACA,qCAAA;EACA,oDAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;AA3DV;AA6DU;EACE,oDAAA;AA3DZ;AAgEM;EACE,cAAA;AA9DR;AAoEE;EACE,qBAAA;EACA,WAAA;AAlEJ;AAoEI;EACE,sCAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAlEN;AAoEM;EACE,wCAAA;EACA,4CAAA;AAlER;AAqEM;EACE,wCAAA;EACA,6CAAA;AAnER;AAsEM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AApER;AAsEQ;EACE,mBAAA;EACA,gBAAA;AApEV;AAuEQ;EACE,iCAAA;AArEV;AA0EI;EACE,gBAAA;EACA,kBAAA;AAxEN;AA0EM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAxER;AA0EQ;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AAxEV;AA4EM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AA1ER;AA8EI;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA5EN;AA8EM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AA5ER;AA8EQ;EACE,0BAAA;AA5EV;AAgFM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA9ER;AAgFQ;EACE,yBAAA;AA9EV;AAiFQ;EACE,aAAA;EACA,4CAAA;AA/EV;AAsFE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AApFJ;AAsFI;EALF;IAMI,sBAAA;IACA,WAAA;EAnFJ;AACF;AAuFE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AArFJ;AAuFI;EAPF;IAQI,sBAAA;EApFJ;AACF;AAsFI;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AApFN;AAsFM;EAVF;IAWI,WAAA;EAnFN;AACF;AAsFI;EACE,sCAAA;EACA,YAAA;AApFN;AAsFM;EACE,4CAAA;AApFR;AAuFM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AArFR;AAwFM;EACE,aAAA;AAtFR;AA0FI;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAxFN;AA0FM;EACE,yBAAA;AAxFR;AA8FE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AA5FJ;;AAgGE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AA7FJ;;AAkGA;EACE;IACE,UAAA;IACA,2BAAA;EA/FF;EAkGA;IACE,UAAA;IACA,wBAAA;EAhGF;AACF;AAmGA;EACE;IACE,UAAA;IACA,2BAAA;EAjGF;EAoGA;IACE,UAAA;IACA,wBAAA;EAlGF;AACF;AAsGA;EACE,UAAA;AApGF;;AAuGA;EACE,mBAAA;EACA,kBAAA;AApGF;;AAuGA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AApGF;;AAuGA;EACE,mBAAA;AApGF;;AAwGA;EAEI;IACE,sBAAA;IACA,WAAA;EAtGJ;EAyGE;IACE,UAAA;EAvGJ;AACF;AA2GA;EAEI;IACE,WAAA;EA1GJ;AACF;AA8GA;EACE;IACE,eAAA;EA5GF;EA8GE;IACE,gBAAA;IACA,WAAA;EA5GJ;EA+GE;;IAEE,aAAA;IACA,oCAAA;EA7GJ;EAiHI;IACE,iBAAA;EA/GN;EAkHI;IACE,mBAAA;EAhHN;EAqHI;;IAEE,iBAAA;IACA,oBAAA;EAnHN;EAwHI;;IAEE,oBAAA;IACA,oBAAA;EAtHN;AACF;AA4HA;EACE;IACE,iBAAA;IACA,UAAA;EA1HF;EA4HE;IACE,gBAAA;IACA,sBAAA;EA1HJ;EA6HE;;;IAGE,aAAA;EA3HJ;AACF","sourcesContent":["// Main Container - Match ExpenseForm styling\r\n.task-form-container {\r\n  min-height: calc(100vh - 118px);\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n.modal-mode-task-content-task-form-container {\r\n  padding: 0rem !important;\r\n   min-height:auto;\r\n}\r\n\r\n// Form Wrapper - Match ExpenseForm wrapper structure\r\n.task-form-wrapper {\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  animation: task-fade-in 0.3s ease-out;\r\n  width: 70%;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n    width: 100%;\r\n  }\r\n\r\n  // Header styling\r\n  .task-form-header {\r\n    position: relative;\r\n    text-align: center;\r\n    margin-bottom: 0rem;\r\n\r\n    .task-form-title {\r\n      font-size: 1.3rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n\r\n    .modal-mode-task-content-task-form-title {\r\n      font-size: 1.3rem !important;\r\n      font-weight: 500 !important;\r\n    }\r\n\r\n    .task-form-close-button {\r\n      position: absolute;\r\n      top: 0;\r\n      right: 0;\r\n      font-size: 24px;\r\n      background: transparent;\r\n      border: none;\r\n      color: #374151;\r\n      cursor: pointer;\r\n      z-index: 2;\r\n      width: 32px;\r\n      height: 32px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 0.25rem;\r\n      transition: all 0.2s ease;\r\n\r\n      &:hover {\r\n        color: #111827;\r\n        background-color: #f3f4f6;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Status Section Styling - NEW\r\n  .task-status-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    padding: 1rem;\r\n    margin: 1.5rem 0 0 0;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 0.375rem;\r\n    background-color: #f9fafb;\r\n\r\n    .current-status,\r\n    .status-actions {\r\n      display: flex;\r\n      align-items: center;\r\n      flex-wrap: wrap;\r\n      gap: 0.75rem;\r\n    }\r\n\r\n    .status-label {\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n    }\r\n\r\n    .status-badge {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      padding: 0.375rem 0.875rem;\r\n      border-radius: 9999px; // Pill shape\r\n      font-size: 0.8125rem;\r\n      font-weight: 500;\r\n      color: white;\r\n      //background-color: var(--success-color);\r\n\r\n      svg {\r\n        color: white;\r\n      }\r\n    }\r\n    \r\n    .status-buttons {\r\n      display: flex;\r\n      gap: 0.75rem;\r\n    }\r\n\r\n    .status-button {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      padding: 0.375rem 0.875rem;\r\n      border: 1.5px solid; // Color set via inline style\r\n      border-radius: 0.375rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      background-color: transparent;\r\n      transition: all 0.2s ease-in-out;\r\n      \r\n      &:hover:not(:disabled) {\r\n        opacity: 0.8;\r\n        transform: translateY(-1px);\r\n      }\r\n      \r\n      &.active {\r\n        font-weight: 600;\r\n        box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n      }\r\n      \r\n      &:disabled {\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n        transform: none;\r\n\r\n        &:hover {\r\n          opacity: 0.6;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Divider styling\r\n  .task-form-divider {\r\n    border: none;\r\n    border-top: 1px solid var(--grey-shade-two);\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n  // Tab styling - updated to match form sections better\r\n  .task-tabs {\r\n    display: flex;\r\n    border: 1px solid var(--grey-shade-three);\r\n    border-radius: 0.375rem 0.375rem 0 0;\r\n    overflow: hidden;\r\n    margin-bottom: 0;\r\n\r\n    .tab-button {\r\n      flex: 1;\r\n      padding: 1rem 1.5rem;\r\n      background: #ffffff;\r\n      border: none;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n      text-align: center;\r\n      color: #6b7280;\r\n\r\n      &.active {\r\n        background-color: var(--grey-shade-two);\r\n        color: #374151;\r\n        border-bottom: 2px solid var(--grey-shade-one);\r\n      }\r\n\r\n      &:hover:not(.active) {\r\n        background-color: var(--grey-lightest-shade);\r\n      }\r\n    }\r\n  }\r\n\r\n  .modal-mode-task-content {\r\n    width: 100% !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  // Form content styling - updated to match the wrapper structure\r\n  .task-form-content,\r\n  .form-content {\r\n    padding: 1.5rem;\r\n    border: 1px solid #e5e7eb;\r\n    border-top: none;\r\n    border-radius: 0 0 0.375rem 0.375rem;\r\n    background-color: #ffffff;\r\n    margin: 0 -1.5rem -1.5rem -1.5rem;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      margin: 0 -1rem -1rem -1rem;\r\n    }\r\n  }\r\n\r\n  // Form sections - NEW: Add section styling like ExpenseForm\r\n  .form-section {\r\n    margin-bottom: 1.5rem; \r\n\r\n    &:last-of-type {\r\n      border-bottom: none;\r\n      margin-bottom: 0;\r\n      padding-bottom: 0;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid var(--grey-shade-two);\r\n    }\r\n  }\r\n\r\n  // Form groups\r\n  .form-group {\r\n    margin-bottom: 0.7rem;\r\n    width: 100%;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    .label-task {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n\r\n      .required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n    // Input styling to match ExpenseForm\r\n    input[type=\"text\"],\r\n    input[type=\"date\"],\r\n    input[type=\"time\"],\r\n    input[type=\"url\"],\r\n    select,\r\n    .custom-dropdown-input,\r\n    .textInput,\r\n    .selectInput {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151 !important;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      height: 2.5rem;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: var(--primary-light-color);\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: var(grey-main-bg);\r\n      }\r\n\r\n      &::placeholder {\r\n        color: var(grey-main-bg);\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #e9ecef;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    select {\r\n      appearance: none;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 0.5rem center;\r\n      background-repeat: no-repeat;\r\n      background-size: 1.5rem 1.5rem;\r\n      padding-right: 2.5rem;\r\n    }\r\n\r\n    // Case selector dropdown - Match ExpenseForm exactly\r\n    .case-selector {\r\n      position: relative;\r\n\r\n      .clear-case-button {\r\n        position: absolute;\r\n        right: 10px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        background: transparent;\r\n        border: none;\r\n        color: #6b7280;\r\n        font-size: 24px;\r\n        cursor: pointer;\r\n        padding: 0;\r\n        width: 24px;\r\n        height: 24px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 50%;\r\n        transition: all 0.2s ease;\r\n        z-index: 1;\r\n\r\n        &:hover {\r\n          background-color: #f3f4f6;\r\n          color: #374151;\r\n        }\r\n\r\n        &:active {\r\n          background-color: #e5e7eb;\r\n        }\r\n      }\r\n\r\n      .dropdown-content {\r\n        position: absolute;\r\n        top: 100%;\r\n        left: 0;\r\n        width: 100%;\r\n        background: #ffffff;\r\n        border: 1px solid #d1d5db;\r\n        border-radius: 0.375rem;\r\n        z-index: 1000;\r\n        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n        margin-top: 0.25rem;\r\n        overflow: hidden;\r\n        animation: dropdown-fade-in 0.2s ease-out;\r\n\r\n        .dropdown-tabs {\r\n          display: flex;\r\n          background: #f9fafb;\r\n          border-bottom: 1px solid #e5e7eb;\r\n\r\n          button {\r\n            flex: 1;\r\n            padding: 0.75rem 1rem;\r\n            border: none;\r\n            background: transparent;\r\n            color: #6b7280;\r\n            font-weight: 500;\r\n            font-size: 0.875rem;\r\n            cursor: pointer;\r\n            transition: all 0.2s ease;\r\n            border-bottom: 2px solid transparent;\r\n\r\n            &:hover {\r\n              background: #f3f4f6;\r\n              color: #374151;\r\n            }\r\n\r\n            &.active {\r\n              background: #ffffff;\r\n              color: var(--primary-light-color);\r\n              font-weight: 600;\r\n              border-bottom-color: var(--primary-light-color);\r\n            }\r\n          }\r\n        }\r\n\r\n        .dropdown-options {\r\n          max-height: 250px;\r\n          overflow-y: auto;\r\n\r\n          .dropdown-option {\r\n            padding: 0.75rem 1rem;\r\n            cursor: pointer;\r\n            border-bottom: 1px solid #f3f4f6;\r\n            transition: all 0.2s ease;\r\n\r\n            &:hover {\r\n              background: #f9fafb;\r\n            }\r\n\r\n            &.selected {\r\n              background: #eff6ff;\r\n              color: #1e40af;\r\n              border-left: 3px solid #3b82f6;\r\n\r\n              .case-parties {\r\n                font-weight: 600;\r\n              }\r\n            }\r\n\r\n            .case-info {\r\n              .case-parties {\r\n                font-weight: 500;\r\n                color: #374151;\r\n                font-size: 0.875rem;\r\n                margin-bottom: 0.25rem;\r\n                line-height: 1.4;\r\n              }\r\n\r\n              .case-ref {\r\n                font-size: 0.75rem;\r\n                color: #6b7280;\r\n                font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas, \"Liberation Mono\", Menlo, monospace;\r\n                background: #f3f4f6;\r\n                padding: 0.125rem 0.375rem;\r\n                border-radius: 0.25rem;\r\n                display: inline-block;\r\n                margin-bottom: 0.25rem;\r\n              }\r\n\r\n              .case-number {\r\n                font-size: 0.75rem;\r\n                color: #9ca3af;\r\n              }\r\n            }\r\n          }\r\n\r\n          .no-data {\r\n            padding: 2rem 1rem;\r\n            text-align: center;\r\n            color: #6b7280;\r\n            font-style: italic;\r\n            font-size: 0.875rem;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Two column layout - Match ExpenseForm\r\n  .date-time-wrapper,\r\n  .expense-form-flex-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    width: 100%;\r\n    margin-bottom: 0.7rem;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    .date-time-group,\r\n    .expense-form-col-half {\r\n      flex: 1;\r\n      margin-bottom: 0;\r\n\r\n      .time-div-task-content {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n      }\r\n\r\n      .date-time-input-task {\r\n        width: 100%;\r\n        padding: 0.5rem;\r\n        border: 1px solid #d1d5db;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.875rem;\r\n        font-family: inherit;\r\n        color: #374151;\r\n        background: #ffffff;\r\n        box-sizing: border-box;\r\n        height: 2.5rem;\r\n\r\n        &:focus {\r\n          outline: none;\r\n          border-color: #3b82f6;\r\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n        }\r\n\r\n        &:hover:not(:focus) {\r\n          border-color: #9ca3af;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Assignee section\r\n  .assignee-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n\r\n    .dropdown-container {\r\n      width: 100%;\r\n    }\r\n\r\n    .assignee-tags {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 0.5rem;\r\n\r\n      .assignee-tag {\r\n        display: flex;\r\n        align-items: center;\r\n        background-color: #eff6ff;\r\n        border: 1px solid #dbeafe;\r\n        border-radius: 0.375rem;\r\n        padding: 0.375rem 0.75rem;\r\n        font-size: 0.875rem;\r\n        color: #374151;\r\n\r\n        .remove-assignee {\r\n          margin-left: 0.5rem;\r\n          background: none;\r\n          border: none;\r\n          color: #6b7280;\r\n          cursor: pointer;\r\n          font-size: 1rem;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          width: 1.25rem;\r\n          height: 1.25rem;\r\n          border-radius: 50%;\r\n          transition: all 0.2s ease;\r\n\r\n          &:hover {\r\n            background-color: #ef4444;\r\n            color: white;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Days selector for recurring tasks\r\n  .days-selector {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    flex-wrap: wrap;\r\n    margin-top: 0.5rem;\r\n\r\n    .day-checkbox {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      cursor: pointer;\r\n      padding: 0.5rem 0.875rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 1.125rem;\r\n      background-color: #ffffff;\r\n      transition: all 0.2s ease;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n      position: relative;\r\n\r\n      input[type=\"checkbox\"] {\r\n        appearance: none;\r\n        width: 1rem;\r\n        height: 1rem;\r\n        border: 1px solid #d1d5db;\r\n        border-radius: 0.25rem;\r\n        background: white;\r\n        position: relative;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n\r\n        &:checked {\r\n          border-color: var(--primary-color);\r\n          background-color: var(--primary-color);\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        background-color: #f9fafb;\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n      &:has(input:checked) {\r\n        border-color: var(--primary-color);\r\n        background-color: #eff6ff;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Frequency dropdown\r\n  .frequency-dropdown {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-family: inherit;\r\n    color: #374151;\r\n    background: #ffffff;\r\n    box-sizing: border-box;\r\n    height: 2.5rem;\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n    background-position: right 0.5rem center;\r\n    background-repeat: no-repeat;\r\n    background-size: 1.5rem 1.5rem;\r\n    padding-right: 2.5rem;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n    &:hover:not(:focus) {\r\n      border-color: #9ca3af;\r\n    }\r\n  }\r\n\r\n  // Rich text editor\r\n  .rich-text-editor {\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.375rem;\r\n    background: #ffffff;\r\n\r\n    .editor-toolbar {\r\n      display: flex;\r\n      padding: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n      background-color: #f9fafb;\r\n      border-top-left-radius: 0.375rem;\r\n      border-top-right-radius: 0.375rem;\r\n      flex-wrap: wrap;\r\n      gap: 0.25rem;\r\n\r\n      button {\r\n        background: none;\r\n        border: none;\r\n        border-radius: 0.25rem;\r\n        color: #6b7280;\r\n        cursor: pointer;\r\n        padding: 0.375rem;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover {\r\n          background-color: #e5e7eb;\r\n          color: #374151;\r\n        }\r\n\r\n        &.active {\r\n          background-color: #3b82f6;\r\n          color: white;\r\n        }\r\n      }\r\n\r\n      .divider {\r\n        width: 1px;\r\n        height: 1.25rem;\r\n        background-color: #e5e7eb;\r\n        margin: 0 0.5rem;\r\n        align-self: center;\r\n      }\r\n    }\r\n\r\n    .link-input-panel {\r\n      background-color: #f8f9fa;\r\n      border-bottom: 1px solid #e5e7eb;\r\n      padding: 0.75rem;\r\n\r\n      .link-input-container {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.5rem;\r\n        width: 100%;\r\n\r\n        .link-input {\r\n          flex: 1;\r\n          padding: 0.5rem 0.75rem;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 0.25rem;\r\n          font-size: 0.875rem;\r\n\r\n          &:focus {\r\n            outline: none;\r\n            border-color: #3b82f6;\r\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n          }\r\n        }\r\n\r\n        .link-actions {\r\n          display: flex;\r\n          gap: 0.25rem;\r\n\r\n          .link-confirm-btn,\r\n          .link-cancel-btn {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: 2rem;\r\n            height: 2rem;\r\n            border: none;\r\n            border-radius: 0.25rem;\r\n            cursor: pointer;\r\n            transition: background-color 0.2s;\r\n\r\n            &:disabled {\r\n              opacity: 0.5;\r\n              cursor: not-allowed;\r\n            }\r\n          }\r\n\r\n          .link-confirm-btn {\r\n            background-color: #16a34a;\r\n            color: white;\r\n\r\n            &:hover:not(:disabled) {\r\n              background-color: #15803d;\r\n            }\r\n          }\r\n\r\n          .link-cancel-btn {\r\n            background-color: #ef4444;\r\n            color: white;\r\n\r\n            &:hover {\r\n              background-color: #dc2626;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .editor-container {\r\n      padding: 0.875rem;\r\n      min-height: 100px;\r\n\r\n      .public-DraftEditor-content {\r\n        min-height: 100px;\r\n\r\n        a {\r\n          color: #3b82f6 !important;\r\n          text-decoration: underline !important;\r\n          background-color: rgba(59, 130, 246, 0.1) !important;\r\n          padding: 1px 2px !important;\r\n          border-radius: 2px !important;\r\n          cursor: pointer !important;\r\n\r\n          &:hover {\r\n            background-color: rgba(59, 130, 246, 0.2) !important;\r\n          }\r\n        }\r\n      }\r\n\r\n      .public-DraftEditorPlaceholder-root {\r\n        color: #9ca3af;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Upload document section - Match ExpenseForm exactly\r\n  .upload-document-group {\r\n    margin-bottom: 1.5rem;\r\n    width: 100%;\r\n\r\n    .upload-document-container {\r\n      border: 2px dashed var(--grey-main-bg);\r\n      border-radius: 0.375rem;\r\n      padding: 2rem;\r\n      text-align: center;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n      background: #fafafa;\r\n\r\n      &:hover {\r\n        border-color: var(--primary-light-color);\r\n        background-color: var(--grey-lightest-shade);\r\n      }\r\n\r\n      &:focus-within {\r\n        border-color: var(--primary-light-color);\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      .upload-icon-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        gap: 0.75rem;\r\n        color: #6b7280;\r\n\r\n        span {\r\n          font-size: 0.875rem;\r\n          font-weight: 500;\r\n        }\r\n\r\n        .upload-icon{\r\n          color: var(--primary-light-color);\r\n        }\r\n      }\r\n    }\r\n\r\n    .upload-progress {\r\n      margin-top: 1rem;\r\n      text-align: center;\r\n\r\n      .progress-bar {\r\n        width: 100%;\r\n        height: 8px;\r\n        background-color: #e5e7eb;\r\n        border-radius: 4px;\r\n        overflow: hidden;\r\n        margin-bottom: 0.5rem;\r\n\r\n        .progress {\r\n          height: 100%;\r\n          background-color: #3b82f6;\r\n          border-radius: 4px;\r\n          transition: width 0.3s ease;\r\n        }\r\n      }\r\n\r\n      span {\r\n        font-size: 0.75rem;\r\n        color: #6b7280;\r\n        font-weight: 500;\r\n      }\r\n    }\r\n\r\n    .uploaded-file {\r\n      margin-top: 1rem;\r\n      padding: 0.75rem 1rem;\r\n      background-color: #f0f9ff;\r\n      border: 1px solid #bae6fd;\r\n      border-radius: 0.375rem;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      gap: 1rem;\r\n\r\n      a {\r\n        color: #0369a1;\r\n        text-decoration: none;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        flex: 1;\r\n\r\n        &:hover {\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n\r\n      .cancel-upload-button {\r\n        background-color: #ef4444;\r\n        color: white;\r\n        border: none;\r\n        padding: 0.375rem 0.75rem;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.75rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover {\r\n          background-color: #dc2626;\r\n        }\r\n\r\n        &:focus {\r\n          outline: none;\r\n          box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Form row styling\r\n  .form-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1.5rem;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n\r\n  // Form actions - Match ExpenseForm exactly\r\n  .form-actions {\r\n    display: flex;\r\n    justify-content: end;\r\n    gap: 1rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n    }\r\n\r\n    .btn-save{\r\n      padding: 0.75rem 1.5rem;\r\n      border: none;\r\n      border-radius: 0.375rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      min-width: 120px;\r\n      transition: all 0.2s ease;\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .btn-save {\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n\r\n      &:hover{\r\n        background-color: var(--primary-light-color);\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #d1d5db;\r\n        color: #9ca3af;\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n    }\r\n\r\n    .btn-cancel {\r\n      padding: 8px 16px;\r\n      border: 1px solid #ddd;\r\n      background: white;\r\n      color: #666;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      font-size: 14px;\r\n\r\n      &:hover {\r\n        background-color: #f8f9fa;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Success/Error messages\r\n  div[role=\"alert\"] {\r\n    border-radius: 0.375rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n  .modal-mode-task-content-task-form-wrapper {\r\n    width: 100%;\r\n    border: none;\r\n    box-shadow: none;\r\n  }\r\n\r\n\r\n// Animations\r\n@keyframes task-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes dropdown-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Scrollbar styling for dropdown\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 3px;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n// Responsive design improvements\r\n@media (max-width: 1024px) {\r\n  .task-form-container {\r\n    .date-time-wrapper {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    .task-form-wrapper {\r\n      width: 85%;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .task-form-container {\r\n    .task-form-wrapper {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .task-form-container {\r\n    padding: 0.5rem;\r\n\r\n    .task-form-wrapper {\r\n      padding: 0.75rem;\r\n      width: 100%;\r\n    }\r\n\r\n    .task-form-content,\r\n    .form-content {\r\n      padding: 1rem;\r\n      margin: 0 -0.75rem -0.75rem -0.75rem;\r\n    }\r\n\r\n    .task-form-header {\r\n      .modal-mode-task-content-task-form-title {\r\n        font-size: 0.8rem;\r\n      }\r\n\r\n      .task-form-title {\r\n        font-size: 1.125rem;\r\n      }\r\n    }\r\n\r\n    .form-group {\r\n      input,\r\n      select {\r\n        padding: 0.375rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n\r\n    .form-actions {\r\n      .btn-save,\r\n      .btn-cancel {\r\n        padding: 0.5rem 1rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .task-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    .task-form-wrapper {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .form-actions,\r\n    .task-form-close-button,\r\n    .upload-document-container {\r\n      display: none;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
